import FlourishComponent from 'components/FlourishComponent';
import React, { forwardRef } from 'react';
import { Row, Col } from 'react-bootstrap';

const EsgTimingBarChart = forwardRef(({ data }, ref) => {
  const [chartLoaded, setChartLoaded] = React.useState(false);
  return (
    <Row className='report-second d-flex to-break w-100 p-0'>
      <Col className={`simple-box d-flex flex-column justify-content-center col-12 m-0`}>
        <Row className='ml-0'>
          <h5 className='title-simple-box text-uppercase mt-1 pl-0'>
            {/* {translations.filter((trans) => trans.code === 'ICS129').map((trans) => trans.text)} */}
            ESG Timing
          </h5>
        </Row>
        <FlourishComponent
          visualizationId='19373801'
          onChartLoad={() => {
            setChartLoaded(true);
          }}
          containerId={`lineChartContainer_ESG`}
          ref={ref}
          withFooter={false}
          style={{ width: '100%' }}
          data={{
            bindings: {
              data: {
                filter: 0,
                label: 1,
                metadata: [],
                value: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
              },
            },
            data: {
              data: data || [],
            },
            metadata: {
              data: {
                0: {
                  type_id: 'string$arbitrary_string',
                  type: 'string',
                  output_format_id: 'string$arbitrary_string',
                },
                1: {
                  type_id: 'string$arbitrary_string',
                  type: 'string',
                  output_format_id: 'string$arbitrary_string',
                },
                2: {
                  type_id: 'number$point_comma',
                  type: 'number',
                  output_format_id: 'number$point_comma',
                },
                3: {
                  type_id: 'number$point_comma',
                  type: 'number',
                  output_format_id: 'number$point_comma',
                },
                4: {
                  type_id: 'number$point_comma',
                  type: 'number',
                  output_format_id: 'number$point_comma',
                },
                5: {
                  type_id: 'number$point_comma',
                  type: 'number',
                  output_format_id: 'number$point_comma',
                },
                6: {
                  type_id: 'number$point_comma',
                  type: 'number',
                  output_format_id: 'number$point_comma',
                },
                7: {
                  type_id: 'number$point_comma',
                  type: 'number',
                  output_format_id: 'number$point_comma',
                },
                8: {
                  type_id: 'number$point_comma',
                  type: 'number',
                  output_format_id: 'number$point_comma',
                },
                9: {
                  type_id: 'number$point_comma',
                  type: 'number',
                  output_format_id: 'number$point_comma',
                },
                10: {
                  type_id: 'number$point_comma',
                  type: 'number',
                  output_format_id: 'number$point_comma',
                },
                11: {
                  type_id: 'number$point_comma',
                  type: 'number',
                  output_format_id: 'number$point_comma',
                },
              },
            },
          }}
          // dataToRespond={[...extractedData.flat()]}
        />
      </Col>
    </Row>
  );
});

export default EsgTimingBarChart;
